<template>
  <a-modal
    :title="isAdd ? '新建人员' : '修改人员'"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 角色 -->
      <a-form-item
        label="角色"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
        v-show="isAdd"
      >
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-decorator="[
            'roleId',
            { rules: [{ required: true, message: '请选择角色' }] },
          ]"
        >
          <a-select-option
            v-for="(item, index) in codeList"
            :key="index"
            :value="item.id"
            >{{ item.roleName }}</a-select-option
          >
        </a-select>
      </a-form-item>

      <!-- 用户名 -->
      <a-form-item
        label="用户名"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          placeholder="请输入"
          v-decorator="[
            'username',
            {
              rules: [
                {
                  required: true,

                  validator: usernameRules,
                },
              ],

              validateTrigger: 'change',
            },
          ]"
        />
      </a-form-item>

      <!-- 密码 -->
      <a-form-item
        label="密码"
        v-if="isAdd"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          placeholder="请输入"
          v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  pattern: /^\S{6,15}$/,
                  message: '请输入长度为6~15位的密码',
                },
              ],
              validateTrigger: 'change',
            },
          ]"
        />
      </a-form-item>

      <!-- 姓名 -->
      <a-form-item
        label="姓名"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          placeholder="请输入"
          v-decorator="[
            'nickname',
            {
              rules: [
                {
                  required: true,
                  pattern: /^.{2,6}$/,
                  message: '请输入长度为2~6位的真实姓名',
                },
              ],
              validateTrigger: 'change',
            },
          ]"
        />
      </a-form-item>

      <!-- 手机号 -->
      <a-form-item
        label="手机号"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 13 } }"
      >
        <a-input
          type="text"
          placeholder="请输入"
          v-decorator="[
            'mobile',
            {
              rules: [
                { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' },
              ],
              validateTrigger: 'change',
            },
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import person from '../../api/person'

export default {
  name: 'personFormModal',
  data() {
    return {
      form: this.$form.createForm(this),
      codeList: [],
      isAdd: true, //是否是新增person
      personId: -1,
      visible: false,
      updateData: {},
      confirmLoading: false,
    }
  },
  methods: {
    usernameRules(rule, value, callback) {
      if (!value || value.trim().length === 0) {
        callback('请输入用户名')
      } else if (!/([A-Za-z]|[\u4E00-\u9FA5])+/.test(value)) {
        callback('请输入含有汉字或字母及长度为2~40位的用户名')
      } else if (value.trim().length > 40 || value.trim().length < 2) {
        callback('请输入长度为2~40位的用户名')
      }
      callback()
    },
    //初始化，显示
    init(type, params) {
      this.visible = true
      this.isAdd = type === 'add' ? true : false

      //初始化form表单数据
      if (params) {
        this.updateData = params
        let formData = {}
        formData.mobile = params.mobile
        formData.nickname = params.nickname
        formData.username = params.username
        formData.roleId = params.accRole.id
        //记录当前学生的ID
        this.personId = params.id
        setTimeout(() => {
          this.form.setFieldsValue(formData)
        }, 100)
      } else {
        this.form.resetFields()
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.$emit('closeForm')
    },

    //新增一个人员
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, value) => {
        console.log('输入的内容是：', value)
        //校验通过
        if (!err) {
          if (this.isAdd) {
            this.addPerson(value)
          } else {
            this.updatePerson(value)
          }
        }
      })
    },

    //新增人员
    addPerson(value) {
      person.addPerson(value).then((res) => {
        this.$message.success('新增成功')
        this.handleCancel()
        this.$emit('addPerson', res.data)
      })
    },

    updatePerson(value) {
      person.updatePerson(this.personId, value).then((res) => {
        this.$message.success('修改成功')
        Object.assign(this.updateData, value)
        this.handleCancel()
      })
    },

    //根据ID获取人员信息
    getPersonById(id) {
      person.getPersonById(id).then((res) => {
        console.log('当前ID人员的信息是：', res.data)
        this.form.setFieldsValue(res.data)
      })
    },
  },
  created() {
    //获取码表信息
    this.$store.dispatch('getInit').then((res) => {
      this.codeList = res.code.filter((item) => {
        if (item.roleName != '代理负责人') {
          return item
        }
      })
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 50px 20px 30px;
  background: white;
  margin: 20px auto;
}
.ap-form {
  width: 400px;
}
.form-oper {
  text-align: center;
  button {
    margin: 0px 5px;
  }
}
</style>
